export const zIndex = {
  fixedButton: 900,
  dropdown: 1000,
  modal: 1010,
};
